/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import Dropdown from '../../../common/dropdown/Dropdown';
import { useForm } from 'react-hook-form';
import Button from '../../global/Button';
import SelectDropDown from '../../../common/dropdown/SelectDropdown';
import { TInfo, TStep4Info } from '../../../types';
import ReactGA from 'react-ga4';
import './businessRegistration.css';
import { useGetBusinessSectorQuery } from '../../../features/businessRegistration/businessRegistrationSlice';
import { decryptJson } from '../../../utils/decryptJson';
import { registerNetcoreActivity } from '../../../utils/registerActivity';
import { Link, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../app/hooks';

type TProps = {
  step1: TInfo;
  setStep1: React.Dispatch<React.SetStateAction<TInfo>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  setPartners: React.Dispatch<React.SetStateAction<TStep4Info[]>>;
  step: number;
};
const AboutBusiness = ({ setStep, setStep1, step1, setPartners, step }: TProps) => {
  const [disable, setDisabled] = useState(false);
  const [description, setDescription] = useState<boolean>();
  const [step1Copy, setStep1Copy] = useState(step1);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const token: any = localStorage.getItem('login-token');
  const details = useAppSelector((state) => state.auth.loggedInUserDetails);

  const { data } = useGetBusinessSectorQuery({ token });

  const sectors = decryptJson(data?.data);

  const methods = useForm({
    mode: 'onChange',
    defaultValues: {
      businessNature: '',
    },
  });
  const {
    formState: { isValid, errors },
  } = methods;

  const [selectedStructureOfBusiness, setSelectedStructureOfBusiness] = useState({
    value: '',
    label: '',
  });
  const [selectedBusinessSegment, setSelectedBusinessSegment] = useState({
    value: '',
    label: '',
  });

  const [selectedNoOfPartners, setSelectedNoOfPartners] = useState({
    value: '',
    label: '',
  });

  const validateInputsResult = useMemo(() => {
    const isSelectedBusinessSegment = step1Copy?.businessSegment
      ? step1Copy.businessSegment !== ''
      : false;
    const isBusinessDescription = step1Copy?.businessDesc?.length >= 80;
    setDescription(isBusinessDescription);
    const isSelectedStructureOfBusiness = step1Copy.structureOfBusiness
      ? step1Copy.structureOfBusiness !== ''
      : false;
    const isNatureOfBusiness = step1Copy.businessNature ? step1Copy.businessNature !== '' : false;
    const length = step1Copy?.noOfPartners ? step1Copy.noOfPartners.length > 0 : false;
    const isNoOfPartners = step1Copy?.structureOfBusiness === 'partnership' ? length : true;

    return (
      isSelectedBusinessSegment &&
      isSelectedStructureOfBusiness &&
      isBusinessDescription &&
      isNatureOfBusiness &&
      isNoOfPartners
    );
  }, [
    step1Copy.businessSegment,
    step1Copy?.structureOfBusiness,
    step1Copy?.businessDesc,
    step1Copy?.noOfPartners,
    step1Copy?.businessNature,
  ]);

  useEffect(() => {
    if (validateInputsResult) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [validateInputsResult]);

  const displayErrorMsg = (errorText: string, variable: string) => {
    if (submitting && !variable) {
      return <div className='text-[red] text-[11px]'>{errorText}</div>;
    }
  };

  return (
    <div className='container stepOneContainer !px-0 !w-[100%] !max-w-[100%] flex justify-center w-full md:!max-w-[700px]'>
      {/* <FormProvider {...methods}> */}
      <form className='w-full formCont !w-[100%]'>
        <div className='w-full'>
          <div className='w-full text-xs mb-[27px] '>
            <SelectDropDown
              className='border rounded-[4px] !h-[52px] !px-[10px] !text-sm md:!px-[16px]'
              label='Business Segment'
              labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
              options={
                data &&
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                sectors?.map((item: any) => {
                  return {
                    label: item.sector,
                    value: item.sector,
                  };
                })
              }
              width='100%'
              setSelectedOption={setSelectedBusinessSegment}
              // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
              onChange={(e) => {
                setStep1Copy({
                  ...step1Copy,
                  businessSegment: selectedBusinessSegment.label,
                });
              }}
              value={step1Copy?.businessSegment}
            />
          </div>
          <div className='mb-[27px]'>
            <div className='mb-[27px]'>
              <label className='flex flex-col relative text-[#212121] '>Nature of Business</label>
              <input
                className='w-full h-[52px] px-[10px] md:px-[16px] border-[1px] border-[#B8C9C9] rounded-[4px] focus:border-[#F8B400] outline-none placeholder:text-xs placeholder:text-[#768396]'
                value={step1Copy?.businessNature}
                placeholder='E.g: branding and marketing'
                onChange={(e) => {
                  setStep1Copy({ ...step1Copy, businessNature: e.target.value });
                }}
              />
            </div>
          </div>
          <div className='mb-[27px] '>
            <div className='block md:flex justify-between'>
              <label htmlFor='describeBusiness'>Describe your business</label>
              {!description && (
                <span className=' md:ml-9 text-errorRed mt-1 md:mt-0 font-Poppins block font-[500] text-[10px]'>
                  Must be 80 characters minimum
                </span>
              )}
            </div>
            <div className='w-full rounded-[5px] outline-none border-[1px] border-[#dddddd] focus:border-[#f8b400]'>
              <textarea
                id='describeBusiness'
                className='w-full outline-none rounded-[4px] h-[120px] placeholder:text-xs text-sm placeholder:text-[#768396] py-[16px] px-[10px] md:px-[16px]'
                placeholder='Please describe your business in nothing less than 80 words'
                value={step1Copy?.businessDesc}
                onChange={(e) => {
                  setStep1Copy({ ...step1Copy, businessDesc: e.target.value });
                }}
                minLength={80}
              />
            </div>
          </div>

          <div className='w-full text-xs mb-[27px] '>
            <Dropdown
              className='border rounded-[4px] h-[52px] !text-[black] !px-[10px] !text-sm'
              label='Structure of business'
              labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
              options={[
                {
                  value: 'Sole proprietorship(One-Man)',
                  label: 'Sole proprietorship(One-Man)',
                },
                { value: 'partnership', label: 'partnership' },
              ]}
              placeholder={selectedStructureOfBusiness.label}
              setSelectedOption={setSelectedStructureOfBusiness}
              width='100%'
              value={step1Copy?.structureOfBusiness}
              // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
              onChange={(e) => {
                setStep1Copy({
                  ...step1Copy,
                  structureOfBusiness: selectedStructureOfBusiness.label,
                });
              }}
              hideSearchBar
            />
            {displayErrorMsg(
              'Structure of business cannot be empty',
              step1Copy?.structureOfBusiness,
            )}
          </div>
          {step1Copy?.structureOfBusiness === 'partnership' && (
            <div className='w-full text-xs mb-[27px] '>
              <Dropdown
                className='border rounded-[2px] h-[52px] text-[#212121] rounded-[6px] '
                label='How many partner?'
                labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
                options={[
                  { label: 'partner 1', value: 'partner 1' },
                  { label: 'partner 2', value: 'partner 2' },
                  { label: 'partner 3', value: 'partner 3' },
                ]}
                width='100%'
                value={step1Copy?.noOfPartners}
                placeholder={selectedNoOfPartners.value}
                setSelectedOption={setSelectedNoOfPartners}
                // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
                onChange={(e) => {
                  setStep1Copy({
                    ...step1Copy,
                    noOfPartners: selectedNoOfPartners.label,
                  });
                  setPartners([]);
                }}
                hideSearchBar
              />
              {displayErrorMsg('Number of partners cannot be empty', step1Copy?.noOfPartners ?? '')}
            </div>
          )}
          {step1Copy.structureOfBusiness !== '' && (
            <div className='flex justify-between  mt-[40px] mb-7 md:mb-[100px] items-center '>
              <Link to='/my-business'>
                <Button
                  className='px-[20px] h-[40px] text-[11px] !bg-[#768396] text-white border-[0px] rounded-[6px] '
                  size='sm'
                  underline={false}
                  theme='secondary'
                  onClick={() => {
                    navigate('/my-business');
                  }}
                >
                  GO BACK
                </Button>
              </Link>
              <Button
                disabled={disable}
                theme='primary'
                className='px-[20px] h-[40px] !rounded-[6px] !border-none text-[11px] inline-block '
                size='sm'
                underline={false}
                onClick={() => {
                  if (!disable) {
                    setStep((currPage) => currPage + 1);
                    setStep1(step1Copy);
                    registerNetcoreActivity(
                      {
                        emailAddress: details?.email,
                        firstName: details?.firstName,
                        lastName: details?.lastName,
                        mobileNumber: details?.phoneNumber,
                      },
                      'TBH_BUSINESS_REGISTRATION_STEP_3',
                    );
                    ReactGA.event({
                      category: 'formSubmit',
                      action: 'TBH_BUSINESS_REGISTRATION_STEP_2',
                      label: 'TBH_BUSINESS_REGISTRATION_STEP_2',
                      // value: 1
                    });
                  }
                  setSubmitting(true);
                }}
                type='submit'
              >
                SAVE AND CONTINUE
              </Button>
            </div>
          )}
        </div>
      </form>
      {/* </FormProvider> */}
    </div>
  );
};

export default AboutBusiness;
